import useTranslation from "utils/hooks/useTranslation";
import { Popup } from "./Popup";
import { useAppSelector } from "store/hooks";
import ProductModalContent1 from "pages/project/ProductInfo/ProductModalContent1";
import ProductModalContent4 from "pages/project/ProductInfo/ProductModalContent4";
import ProductModalContent5 from "pages/project/ProductInfo/ProductModalContent5";
import ProductModalContent3 from "pages/project/ProductInfo/ProductModalContent3";
import ProductModalContent2 from "pages/project/ProductInfo/ProductModalContent2";
import ProductModalContent7 from "pages/project/ProductInfo/ProductModalContent7";
import { useCallback, useEffect, useMemo, useState } from "react";
import Scroll from "components/shared/scroll";
import { writeDataLayer } from "utils/helpers";

interface SelectedComponentProps {
    data?: any;
}

export const ProductPopup: React.FC<{
    closePopup: () => void;
    product?: any;
}> = ({ /*closePopup,*/ product }) => {
    const { t } = useTranslation();
    const authState = useAppSelector((state) => state.auth);
    const projectStore = useAppSelector((state) => state.project);
    const [selectedMenu, setSelectedMenu] = useState(0);

    const [data, setData] = useState<{
        SelectedComponent: React.ComponentType<SelectedComponentProps> | null;
    }>({
        SelectedComponent: null,
    });


    const menuItems = useMemo(()=> [
        { label: t('PRODCTMODAL_MENU_1'), component: ProductModalContent1 },
        { label: t('PRODCTMODAL_MENU_2'), component: ProductModalContent4 },
        { label: t('PRODCTMODAL_MENU_4'), component: ProductModalContent5 },
        { label: t('PRODCTMODAL_MENU_5'), component: ProductModalContent3 },
        { label: t('PRODCTMODAL_MENU_6'), component: ProductModalContent2 },
        ...(projectStore.project.simulationCool ? [{ label: t('PRODCTMODAL_MENU_7'), component: ProductModalContent7 }] : [])
    ],[projectStore.project.simulationCool, t]);

    useEffect(() => {
        writeDataLayer('produit', authState);
    }, []);

    useEffect(() => {
        setData((prev) => ({
                ...prev, SelectedComponent: menuItems[0].component as React.ComponentType<SelectedComponentProps> }));
    }, [])

    const SelectMenu = useCallback((index: number) => {
        setSelectedMenu(index);
        setData({ ...data, SelectedComponent: menuItems[index].component as React.ComponentType<SelectedComponentProps> });
    }, [menuItems, data])

    return (<Popup
        title={t("PRODUCT_DETAILS")}
        translateTitle
        fixSize="large">
        <>

            <group
                //data-scroll=""
                data-contain=""
                data-direction="column"
                data-wrap="no"
                data-height="fit"
            >
                <group className="tab_strip_nav " data-background="white">
                    <group data-type="snap" data-length="autofit">
                        <Scroll>
                            <group
                                data-wrap="no"
                                data-space-horizontal="50"
                                data-gap="20"
                            >
                                {menuItems.map((item: any, index: number) => {
                                    return (
                                        <group
                                            key={index}
                                            //data-length="autofit"
                                            data-width="auto"
                                            data-cursor="pointer"
                                            data-align="center"
                                            data-height="50"
                                            data-space="10"
                                            data-gap="10"
                                            data-wrap="no"
                                            data-justify="center"
                                            data-interactive=""
                                            {...(index === selectedMenu ? { "data-color": "secondary" } : {})}
                                            onClick={() => SelectMenu(index)}
                                        >
                                            <text
                                                data-wrap="wrap"
                                                data-width="auto"
                                            >{item.label}</text>
                                        </group>
                                    )
                                })}

                            </group>
                        </Scroll>
                    </group>
                </group>
                <group data-height="autofit" data-scroll="">

                    {data.SelectedComponent && <data.SelectedComponent data={product} />}
                </group>


            </group>


        </>
    </Popup>)
}